const getters = {
  getterIsToBUser(state) {
    return state.isToBUser;
  },
  getterUserCompanyObject(state) {
    return state.userCompanyObject;
  },
  getterOrderList(state) {
    return state.orderList;
  },
  getterOrderDetailObject(state) {
    return state.orderDetailObject;
  },
  getterOrderDetailReceiveList(state) {
    return state.orderDetailReceiveList;
  },
  getterShareOrderDetailObject(state) {
    return state.shareOrderDetailObject;
  },
  getterShareReceivedList(state) {
    return state.shareReceivedList;
  },
};
export default getters;
